// Configurações do Keycloak
export const KEYCLOAK_CONFIG = {
  URL: import.meta.env.VITE_KEYCLOAK_URL || "https://localhost:8443",
  REALM: import.meta.env.VITE_KEYCLOAK_REALM || "oauth2_front",
  CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "client_auth_code",
  CLIENT_SECRET: import.meta.env.VITE_KEYCLOAK_CLIENT_SECRET || null, // Opcional
  REDIRECT_URI:
    import.meta.env.VITE_KEYCLOAK_REDIRECT_URI ||
    "http://localhost:3000/callback",
} as const;

// Função para verificar se Client Authentication está habilitado
export const isClientAuthenticationEnabled = (): boolean => {
  return !!KEYCLOAK_CONFIG.CLIENT_SECRET;
};

// URLs dos endpoints do Keycloak
export const KEYCLOAK_ENDPOINTS = {
  AUTHORIZATION: `${KEYCLOAK_CONFIG.URL}/realms/${KEYCLOAK_CONFIG.REALM}/protocol/openid-connect/auth`,
  TOKEN: `${KEYCLOAK_CONFIG.URL}/realms/${KEYCLOAK_CONFIG.REALM}/protocol/openid-connect/token`,
  LOGOUT: `${KEYCLOAK_CONFIG.URL}/realms/${KEYCLOAK_CONFIG.REALM}/protocol/openid-connect/logout`,
  USER_INFO: `${KEYCLOAK_CONFIG.URL}/realms/${KEYCLOAK_CONFIG.REALM}/protocol/openid-connect/userinfo`,
} as const;

// Parâmetros para a URL de autorização
export const AUTH_PARAMS = {
  response_type: "code",
  client_id: KEYCLOAK_CONFIG.CLIENT_ID,
  redirect_uri: KEYCLOAK_CONFIG.REDIRECT_URI,
  scope: "openid profile email",
} as const;
